export default __webpack_public_path__ + "static/media/complementary--pass-right--g1.8143583a.png";